export { default as AboutView } from './AboutView';
export { default as AppNotificationView } from './AppNotificationView';
export { default as BrotherCollaborationView } from './BrotherCollaborationView';
export { default as CaseStudiesView } from './CaseStudiesView';
export { default as CaseStudiesVisualExpiriencesView } from './CaseStudiesVisualExpiriencesView';
export { default as ContactUsQrView } from './ContactUsQrView';
export { default as ContactUsView } from './ContactUsView';
export { default as DownloadBrochureView } from './DownloadBrochureView';
export { default as FaqView } from './FaqView';
export { default as FooterView } from './FooterView';
export { default as FreeTrialView } from './FreeTrialView';
export { default as GetInTouchQrView } from './GetInTouchQrView';
export { default as GetInTouchView } from './GetInTouchView';
export { default as HaveQuestionsView } from './HaveQuestionsView';
export { default as HeaderView } from './HeaderView';
export { default as HeroView } from './HeroView';
export { default as HowItWorksView } from './HowItWorksView';
export { default as HowQrWorksView } from './HowQrWorksView';
export { default as HubFooterView } from './HubFooterView';
export { default as HubHeaderView } from './HubHeaderView';
export { default as HubHeroView } from './HubHeroView';
export { default as JoinQrView } from './JoinQrView';
export { default as LearnMoreView } from './LearnMoreView';
export { default as LearnTestExportView } from './LearnTestExportView';
export { default as NewView } from './NewView';
export { default as NewsPageView } from './NewsPageView';
export { default as OurClientsView } from './OurClientsView';
export { default as PriceCardsView } from './PriceCardsView';
export { default as PricingView } from './PricingView';
export { default as QrAboutView } from './QrAboutView';
export { default as QrHeaderView } from './QrHeaderView';
export { default as QrHeroView } from './QrHeroView';
export { default as QrVideoView } from './QrVideoView';
export { default as QuotesView } from './QuotesView';
export { default as SamplesView } from './SamplesView';
export { default as SeeHowView } from './SeeHowView';
export { default as TaggisAndDocBrowserView } from './TaggisAndDocBrowserView';
export { default as TermsDialogView } from './TermsDialogView';
export { default as TrialOfferView } from './TrialOfferView';
export { default as UploadVisualsView } from './UploadVisualsView';
export { default as WatchTaggisView } from './WatchTaggisView';
export { default as WebsiteCardsView } from './WebsiteCardsView';
export { default as WhoWeAreView } from './WhoWeAreView';
export { default as WorkplaceChallengesView } from './WorkplaceChallengesView';



// WEBPACK FOOTER //
// ./src/components/views/index.js